<template>
	<j-card class="xs-12 bg5 r2 p4 mt6">
		<div class="fs5 lh125 fw7 mb1">{{ $t("invite_client") }}</div>
		<div class="lh125 c6">{{ $t("invite_client_description") }}</div>
		<j-button
			@click="$modal.show('hkecicInviteClient')"
			class="mt4"
			type="bordered"
			>{{ $t("invite") }}</j-button
		>

		<!-- Modal to invite -->
		<core-modal name="hkecicInviteClient" :headline="$t('invite')">
			<hkecic-invite-client-modal
				:entity="entity"
				@invite:finished="$modal.hide('hkecicInviteClient')"
			/>
		</core-modal>
	</j-card>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import HkecicInviteClientModal from "./HkecicInviteClientModal"

export default {
	components: { CoreModal, JCard, JButton, HkecicInviteClientModal },
	props: {
		entity: {
			type: Object,
			default: () => ({})
		}
	}
}
</script>
